export default __webpack_public_path__ + "static/tadandoonda-493002546179ee83a22a234506ecbd22.png";